import { LoanActionType } from "./action-type"

export const actionSendLoanProposal = (payload, callBack) => ({
    type: LoanActionType.SEND_PROPOSAL,
    payload,
    callBack
});